module.exports = __webpack_public_path__ + "static/media/brushsmoothness.4bad7455.svg";